import { Component, OnInit } from '@angular/core';
import { RouterLink }          from '@angular/router';

@Component({
    selector: 'register-modal',
    templateUrl: './register-modal.component.html'
})
export class RegisterModalComponent implements OnInit {

    constructor() { }

    ngOnInit() {
    }

}
